import i18next, { type i18n as I18nInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { ar } from './locales/ar.ts';
import { en } from './locales/en.ts';
import { fr } from './locales/fr.ts';

export const SUPPORTED_LOCALES = ['fr', 'ar', 'en'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

const RTL_LOCALES: readonly Locale[] = ['ar'];

export const isLocale = (value: string): value is Locale =>
  (SUPPORTED_LOCALES as readonly string[]).includes(value);

export const localeDirection = (locale: string): 'ltr' | 'rtl' =>
  isLocale(locale) && RTL_LOCALES.includes(locale) ? 'rtl' : 'ltr';

export const createI18n = async (defaultLocale: Locale): Promise<I18nInstance> => {
  const instance = i18next.createInstance();
  await instance.use(initReactI18next).init({
    resources: { fr: { translation: fr }, ar: { translation: ar }, en: { translation: en } },
    lng: defaultLocale,
    fallbackLng: 'fr',
    supportedLngs: [...SUPPORTED_LOCALES],
    interpolation: { escapeValue: false },
    returnNull: false,
  });
  return instance;
};
